import { render, staticRenderFns } from "./DimensionEditor.vue?vue&type=template&id=f4ffe4c4&scoped=true"
import script from "./DimensionEditor.vue?vue&type=script&lang=js"
export * from "./DimensionEditor.vue?vue&type=script&lang=js"
import style0 from "./DimensionEditor.vue?vue&type=style&index=0&id=f4ffe4c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4ffe4c4",
  null
  
)

export default component.exports